// Whole Component Tejashwini
import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Layout from "./layout";
import EditIcon from "@mui/icons-material/Edit"; // Importing Edit icon
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate and useLocation
import axios from "axios";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ProfileForm from "./profileUpdateform";
import Modal from "@mui/material/Modal";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const style = {
  position: "absolute",
  top: "58%", // Center vertically
  left: "51%",
  transform: "translate(-50%, -50%)",
  width: "25%", // Reduced width for a smaller form
  bgcolor: "background.paper",
  border: "none",
  boxShadow: "none",
  p: 1, // Reduced padding
};

export default function Profile() {
  const [roles, setRoles] = useState([]);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    role_name: "",
    contact_no: "",
    created_by: "System",
    email_id: "",
    gender: "", // Add gender
    date_of_birth: "", // Add date of birth
  });
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [refresh, setRefresh] = useState(false);
  const [modalClosed, setModalClosed] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // Fetch user data using JWT token in headers
  useEffect(() => {
    fetchUserData();
  }, [refreshKey]);

  const fetchUserData = async () => {
    try {
      const email = localStorage.getItem("user_email");

      if (!email) {
        setErrors({ apiError: "User email not found" });
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
        { email },
        { headers: { user_email: email } },
      );

      if (response.status === 200) {
        setFormData(response.data.user);
        setRoles(response.data.roles);
      } else {
        setErrors({ apiError: "Failed to fetch user data" });
      }
    } catch (error) {
      setErrors({ apiError: "Error fetching data" });
    }
  };

  const updateUserData = async (updatedData) => {
    try {
      // Get the email from localStorage
      const email = localStorage.getItem("user_email");

      if (!email) {
        setErrors({ apiError: "User email not found" });
        return;
      }

      // Call the API to update user data by email using fetch
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/updateUser`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            user_email: email, // Use the email stored in localStorage
          },
          body: JSON.stringify(updatedData), // Send the updated data in the request body
        },
      );

      if (response.ok) {
        const data = await response.json();

        // alert("User data updated successfully");
      } else {
        console.error("Failed to update user data");
      }
    } catch (error) {
      console.error("Error in update request:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEditClick = async () => {
    setIsEditing(true);
    await updateUserData(formData);
    setModalClosed(true);
    setSnackbarMessage("User data updated successfully");
  };

  const handleModelClose = () => {
    setIsEditing(false);
    if (modalClosed) {
      setSnackbarOpen(true);
    }
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const handleclose = () => {
    setIsEditing(false);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      <Layout />
      <h1
        className="title"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
          gap: "7em",
          fontSize: "14px",
          left: "10px",
          fontWeight: "10px",
        }}
      >
        {" "}
        Profile
      </h1>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "5em",
        }}
      >
        <AccountCircleIcon
          sx={{
            width: 80,
            height: 80,
            color: "#0A64A2",
            borderRadius: "50%",
            marginBottom: 2,
          }}
        />
      </Box>
      <Box sx={style}>
        <IconButton
          aria-label="edit"
          onClick={handleEditClick}
          sx={{
            position: "absolute",
            right: 20,
            bottom: "12em",
            color: (theme) => theme.palette.grey[500],
            display: "flex",
            alignItems: "center",
          }}
        >
          <EditIcon sx={{ color: "#0A64A2", marginRight: 0.5 }} />
          <Typography variant="body2" sx={{ color: "#0A64A2" }}>
            Edit
          </Typography>
        </IconButton>

        <Modal open={isEditing} onClose={handleEditClick}>
          <ProfileForm
            userData={formData}
            roles={roles}
            handleModelClose={handleModelClose}
            handleInputChange={handleInputChange}
            handleclose={handleclose}
            updateUserData={updateUserData}
            fetchUserData={fetchUserData}
          />
        </Modal>
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "start",
              gap: 2,
              mt: 1,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                First Name:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                Last Name:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                Gender:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                Date of Birth:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                Role:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                Contact Number:
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", width: "150px", textAlign: "right" }}
              >
                Email:
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              <Typography variant="body1">{formData.first_name}</Typography>
              <Typography variant="body1">{formData.last_name}</Typography>
              <Typography variant="body1">{formData.gender}</Typography>
              <Typography variant="body1">{formData.date_of_birth}</Typography>
              <Typography variant="body1">{formData.role_name}</Typography>
              <Typography variant="body1">{formData.contact_no}</Typography>
              <Typography variant="body1">{formData.email_id}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000} // Duration before it automatically closes
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setSnackbarOpen(false)} // Close handler
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
